import { cx } from 'cva'
import type { ComponentPropsWithoutRef, FC } from 'react'
import { FontAwesomeIcon } from './FontAwesomeIcon'
import InputError from './InputError'

export type FormInputTextProps = ComponentPropsWithoutRef<'input'> & {
	label: string
	error?: string
}

export const FormInputText: FC<FormInputTextProps> = ({ label, error, id, ...props }) => {
	const hasError = !!error
	const labelClasses = cx('text-body-sm', hasError ? 'text-error' : 'text-blue-shade-40')
	const inputClasses = cx(
		'w-full h-16 rounded-xs outline-(length:--stroke-sm) -outline-offset-(length:--stroke-sm) px-4 focus:outline-(length:--stroke-md) focus:-outline-offset-(length:--stroke-md) text-h5 text-blue-shade-40',
		hasError ? 'outline-error' : 'outline-grey-20 focus:outline-blue',
	)

	return (
		<div className="flex w-full flex-col gap-y-2 relative">
			<label className={labelClasses} htmlFor={id}>
				{label}
			</label>
			<div className="relative w-full">
				<input className={inputClasses} id={id} {...props} />
				<FontAwesomeIcon
					icon={['far', 'diamond-exclamation']}
					size="2xl"
					className={cx(
						'text-error absolute right-6 bottom-4 opacity-0 pointer-events-none transition-opacity duration-200 ease-in-out',
						hasError && 'opacity-100',
					)}
				/>
			</div>
			<InputError error={error} />
		</div>
	)
}

export default FormInputText
